import emailjs from '@emailjs/browser';
import { logEmail } from '../firebase/firestoreService';

const MONTH_NAMES = [
  'Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno',
  'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre',
];

export async function sendTimesheetEmail(timesheet, client, user, userId) {
  const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
  const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
  const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

  if (!serviceId || !templateId || !publicKey) {
    throw new Error(
      'EmailJS non configurato. Aggiungi le variabili ambiente:\n' +
      '- REACT_APP_EMAILJS_SERVICE_ID\n' +
      '- REACT_APP_EMAILJS_TEMPLATE_ID\n' +
      '- REACT_APP_EMAILJS_PUBLIC_KEY\n\n' +
      'Registrati su https://www.emailjs.com per ottenere le credenziali.'
    );
  }

  const toEmail = client?.email || client?.pecEmail;
  if (!toEmail) {
    throw new Error('Nessun indirizzo email trovato per il cliente. Aggiungi un\'email o PEC nell\'anagrafica cliente.');
  }

  const fromName = `${user?.firstName || ''} ${user?.lastName || ''}`.trim() || 'Professionista';
  const monthYear = `${MONTH_NAMES[timesheet.month - 1]} ${timesheet.year}`;

  const params = {
    to_email: toEmail,
    from_name: fromName,
    client_name: client?.name || timesheet.clientName,
    month_year: monthYear,
    total_days: timesheet.totalDays || 0,
    total_amount: (timesheet.totalAmount || 0).toLocaleString('it-IT', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }),
  };

  await emailjs.send(serviceId, templateId, params, publicKey);

  // Log email in Firestore
  if (userId) {
    try {
      await logEmail(userId, {
        clientId: client?.id || null,
        clientName: client?.name || timesheet.clientName,
        type: 'timesheet',
        subject: `Timesheet ${monthYear}`,
        sentTo: toEmail,
        recipientType: toEmail === client?.pecEmail ? 'pec' : 'email',
        triggeredBy: 'ui',
        status: 'sent',
        timesheetData: {
          month: timesheet.month,
          year: timesheet.year,
          totalDays: timesheet.totalDays || 0,
          totalAmount: timesheet.totalAmount || 0,
        },
      });
    } catch (logErr) {
      console.warn('[TimesheetEmail] Log email fallito:', logErr);
    }
  }

  // Invia copia all'utente
  if (user?.email) {
    try {
      const userCopyParams = {
        to_email: user.email,
        reply_to: 'noreply@forfy.it',
        from_name: 'Forfy',
        client_name: client?.name || timesheet.clientName,
        month_year: monthYear,
        total_days: timesheet.totalDays || 0,
        total_amount: params.total_amount,
      };

      await emailjs.send(serviceId, templateId, userCopyParams, publicKey);
      console.log('[TimesheetEmail] Copia inviata a utente:', user.email);
    } catch (copyError) {
      console.warn('[TimesheetEmail] Copia a utente fallita:', copyError);
    }
  }

  return { sentTo: toEmail, sentAt: new Date().toISOString() };
}
